import { motion } from "framer-motion";
import { fadeUp, stagger, viewport } from "../../lib/motion";

const steps = [
  { n: "01", title: "Baixe o app", desc: "Instale o Delivery Maracás na App Store ou Google Play, é grátis." },
  { n: "02", title: "Escolha o que quiser", desc: "Navegue pelas lojas da cidade, monte seu pedido e finalize em segundos." },
  { n: "03", title: "Receba rapidinho", desc: "Acompanhe o entregador em tempo real até chegar na sua porta." },
];

export const HowItWorks = () => (
  <section id="como-funciona" className="bg-slate-50 py-24 md:py-32" data-testid="how-section">
    <div className="mx-auto max-w-8xl px-5 md:px-10">
      <div className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div className="max-w-xl">
          <p className="mb-3 font-mono text-xs font-bold uppercase tracking-[0.2em] text-maraca-pink">
            Simples assim
          </p>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-maraca-navy md:text-5xl lg:text-6xl">
            Como funciona
          </h2>
        </div>
      </div>

      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="grid gap-6 md:grid-cols-3">
        {steps.map((s, i) => (
          <motion.div
            key={s.n}
            variants={fadeUp}
            data-testid={`step-${s.n}`}
            className="relative rounded-3xl border border-black/5 bg-white p-8 transition-transform duration-300 hover:-translate-y-1"
          >
            <span className="font-mono text-6xl font-bold text-maraca-teal/30">{s.n}</span>
            <h3 className="mt-4 font-display text-2xl font-bold text-maraca-navy">{s.title}</h3>
            <p className="mt-2 leading-relaxed text-maraca-navy/70">{s.desc}</p>
            {i < steps.length - 1 && (
              <span className="absolute -right-3 top-1/2 hidden h-6 w-6 -translate-y-1/2 rotate-45 border-r-2 border-t-2 border-maraca-amber md:block" />
            )}
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
